import { authFetch } from './api.js';
import { registerViewLoader } from './navigation.js';
import { showToast } from './utils.js';

function getLoginPayload(payload) {
  return payload?.login || payload || {};
}

function setLoading(button, loading, text) {
  if (!button) return;
  button.disabled = loading;
  button.textContent = loading ? text : button.dataset.defaultLabel;
}

function renderSifLoginStatus(payload) {
  const state = document.getElementById('sif-login-state');
  const message = document.getElementById('sif-login-message');
  const qrWrap = document.getElementById('sif-login-qr-wrap');
  const qr = document.getElementById('sif-login-qr');
  const checkedAt = document.getElementById('sif-login-checked-at');
  const login = getLoginPayload(payload);
  const status = payload?.status || login?.status || 'unhealthy';
  const ready = status === 'ready' || login?.authenticated === true;
  const loginRequired = status === 'login_required';

  if (state) {
    state.textContent = ready ? '已登录' : loginRequired ? '需要扫码登录' : '服务异常';
    state.className = `status-badge ${ready ? 'status-active' : loginRequired ? 'status-pending' : 'status-disabled'}`;
  }
  if (message) {
    message.textContent = payload?.message || (ready
      ? 'SIF 登录态有效，可以正常执行关键词任务。'
      : loginRequired
        ? '登录态已失效，请使用下方二维码完成扫码。'
        : 'SIF 服务不可用，请检查容器运行状态。');
  }
  if (qrWrap && qr) {
    const dataUrl = login?.screenshotDataUrl || '';
    qrWrap.hidden = !dataUrl;
    qr.src = dataUrl;
  }
  if (checkedAt) {
    const timestamp = login?.checkedAt || payload?.checkedAt;
    checkedAt.textContent = timestamp ? `最近检测：${new Date(timestamp).toLocaleString()}` : '';
  }
}

async function requestSifStatus() {
  const response = await authFetch('/api/admin/sif/login-status');
  const payload = await response.json().catch(() => ({}));
  if (!response.ok && payload?.status !== 'unhealthy') {
    throw new Error(payload.error || payload.message || '检查 SIF 登录态失败');
  }
  return payload;
}

async function startSifLogin() {
  const response = await authFetch('/api/admin/sif/login-session', { method: 'POST', body: JSON.stringify({ marketplace: 'US', forceLogin: true }) });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || payload.message || '生成 SIF 登录二维码失败');
  return payload;
}

async function refreshSifLogin() {
  const response = await authFetch('/api/admin/sif/login-session/refresh', { method: 'POST', body: JSON.stringify({ marketplace: 'US' }) });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || payload.message || '刷新 SIF 登录二维码失败');
  return payload;
}

export async function loadSifLogin() {
  const checkButton = document.getElementById('sif-login-check-btn');
  try {
    setLoading(checkButton, true, '检测中…');
    const status = await requestSifStatus();
    renderSifLoginStatus(status);
    if (status?.status === 'login_required') {
      const session = await startSifLogin();
      renderSifLoginStatus(session);
    }
  } catch (error) {
    renderSifLoginStatus({ status: 'unhealthy', message: error.message || '检查 SIF 登录态失败' });
    showToast(error.message || '检查 SIF 登录态失败', 'error');
  } finally {
    setLoading(checkButton, false);
  }
}

async function handleRefresh() {
  const refreshButton = document.getElementById('sif-login-refresh-btn');
  try {
    setLoading(refreshButton, true, '刷新中…');
    const session = await refreshSifLogin();
    renderSifLoginStatus(session);
    if (session?.status === 'ready') {
      showToast('SIF 登录态已恢复', 'success');
    }
  } catch (error) {
    showToast(error.message || '刷新 SIF 登录二维码失败', 'error');
  } finally {
    setLoading(refreshButton, false);
  }
}

export function initSifLogin() {
  const checkButton = document.getElementById('sif-login-check-btn');
  const refreshButton = document.getElementById('sif-login-refresh-btn');
  [checkButton, refreshButton].filter(Boolean).forEach((button) => {
    button.dataset.defaultLabel = button.textContent;
  });
  registerViewLoader('admin-sif-login', () => loadSifLogin());
  checkButton?.addEventListener('click', () => loadSifLogin());
  refreshButton?.addEventListener('click', () => handleRefresh());
}
